import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import "./i18n"
import { BrowserRouter } from "react-router-dom"
import Auth0ProviderWithNavigate from "./components/Auth0ProviderWithNavigate/Auth0ProviderWithNavigate"
import { useEffect, useState } from "react"
import Loading from "./components/Loading/Loading"

function Root() {
  const [isReady, setReady] = useState(false)

  useEffect(() => {
    async function init() {
      if (typeof window !== "undefined") {
        const t =
          localStorage.getItem("auth_token") ||
          sessionStorage.getItem("auth_token")

        if (t) {
          try {
            const { exp } = JSON.parse(atob(t.split(".")[1]))
            if (Date.now() < exp * 1000) {
              console.log("[index.js] Mode Puppeteer détecté")
              window.__puppeteerAuth = true
            } else {
              localStorage.removeItem("auth_token")
              sessionStorage.removeItem("auth_token")
            }
          } catch {}
        }
      }

      await new Promise((r) => setTimeout(r, 20))

      setReady(true)
    }

    init()
  }, [])

  if (!isReady) {
    return <Loading message="Chargement..." opacity={1} size={80} />
  }

  return (
    <BrowserRouter>
      <Auth0ProviderWithNavigate
        skipRedirectCallback={window.__puppeteerAuth === true}
      >
        <App />
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  )
}

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<Root />)